/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExternalDocumentation } from './common/ExternalDocumentation';
import { IExternalDocumentationParent } from './common/IExternalDocumentationParent';
import { Info } from './common/Info';
import { Tag } from './common/Tag';
import { IVisitor } from '../visitors/IVisitor';
import { ExtensibleNode } from './ExtensibleNode';

/**
 * Constructor.
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class Document extends ExtensibleNode implements IExternalDocumentationParent {
    public info : Info;

    public tags : Array<Tag>;

    public externalDocs : ExternalDocumentation;

    public constructor() {
        super();
        if(this.info===undefined) this.info = null;
        if(this.tags===undefined) this.tags = null;
        if(this.externalDocs===undefined) this.externalDocs = null;
        this._ownerDocument = this;
        this._parent = null;
    }

    /**
     * Called to get the type of document.
     * @return {DocumentType}
     */
    public abstract getDocumentType() : DocumentType;

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitDocument(this);
    }

    /**
     * Creates an Info node.
     * @return {Info}
     */
    public abstract createInfo() : Info;

    /**
     * Creates a Tag node.
     * @return {Tag}
     */
    public abstract createTag() : Tag;

    /**
     * Adds a tag.
     * @param {string} name
     * @param {string} description
     * @return {Tag}
     */
    public addTag(name : string, description : string) : Tag {
        let tag : Tag = this.createTag();
        tag.name = name;
        tag.description = description;
        if(this.tags == null) {
            this.tags = <any>([]);
        }
        /* add */(this.tags.push(tag)>0);
        return tag;
    }

    /**
     * Creates an External Documentation node.
     * @return {ExternalDocumentation}
     */
    public abstract createExternalDocumentation() : ExternalDocumentation;

    public setExternalDocumentation$io_apicurio_datamodels_core_models_common_ExternalDocumentation(externalDocs : ExternalDocumentation) {
        this.externalDocs = externalDocs;
    }

    public setExternalDocumentation$java_lang_String$java_lang_String(description : string, url : string) : ExternalDocumentation {
        let ed : ExternalDocumentation = this.createExternalDocumentation();
        ed.description = description;
        ed.url = url;
        this.externalDocs = ed;
        return ed;
    }

    /**
     * Sets the external documentation information.
     * @param {string} description
     * @param {string} url
     * @return {ExternalDocumentation}
     */
    public setExternalDocumentation(description? : any, url? : any) : any {
        if(((typeof description === 'string') || description === null) && ((typeof url === 'string') || url === null)) {
            return <any>this.setExternalDocumentation$java_lang_String$java_lang_String(description, url);
        } else if(((description != null && description instanceof <any>ExternalDocumentation) || description === null) && url === undefined) {
            return <any>this.setExternalDocumentation$io_apicurio_datamodels_core_models_common_ExternalDocumentation(description);
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @return {boolean}
     */
    public isAttached() : boolean {
        return true;
    }
}
Document["__class"] = "io.apicurio.datamodels.core.models.Document";
Document["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { DocumentType } from './DocumentType';

